import { cn } from '@playbooks/ui/lib/utils'
import { ReactNode } from 'react'

export default function ElementWrapper({ component, locked }: { component: ReactNode; locked?: boolean }) {
  return <div className={cn(locked && 'pointer-events-none')}>{component}</div>
}
